<script>
import { Line } from "vue-chartjs";
import { CustomTooltips } from "@coreui/coreui-plugin-chartjs-custom-tooltips";
import { getStyle } from "@coreui/coreui/dist/js/coreui-utilities";
import { setTimeout, clearTimeout } from "timers";

export default {
  computed: {},
  data() {
    return {
      timeout: null,
      refreshData: [
        {
          label: "Sales",
          backgroundColor: getStyle("--primary") || "#20a8d8",
          borderColor: "rgba(255,255,255,.55)",
          data: this.dataToRefresh()
        }
      ]
    };
  },
  methods: {
    dataToRefresh() {
      var a = [65000, 89500, 104000, 84555, 51005, 55980, 105000].map(function(
        x
      ) {
        return x * 1.1;
      });
      //return [65000, 89500, 104000, 84555, 51005, 55980, 105000]
      return a;
    }
  },
  extends: Line,
  props: ["height", "width"],
  mounted() {
    const brandPrimary = getStyle("--primary") || "#20a8d8";
    const datasets1 = [
      {
        label: "Sales",
        backgroundColor: brandPrimary,
        borderColor: "rgba(255,255,255,.55)",
        data: [65000, 89500, 104000, 84555, 51005, 55980, 105000]
      }
    ];

    this.renderChart(
      {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July"
        ],
        //datasets: datasets1
        datasets: this.refreshData
      },
      {
        tooltips: {
          enabled: false,
          custom: CustomTooltips
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                color: "transparent",
                zeroLineColor: "transparent"
              },
              ticks: {
                fontSize: 2,
                fontColor: "transparent"
              }
            }
          ],
          yAxes: [
            {
              display: false,
              ticks: {
                display: false,
                //min: Math.min.apply(Math, datasets1[0].data) - 5,
                //max: Math.max.apply(Math, datasets1[0].data) + 5
                min: Math.min.apply(Math, datasets1[0].data) - 5,
                max: Math.max.apply(Math, datasets1[0].data) + 5
              }
            }
          ]
        },
        elements: {
          line: {
            borderWidth: 1
          },
          point: {
            radius: 4,
            hitRadius: 10,
            hoverRadius: 4
          }
        }
      }
    );
  }
};
</script>
